module.exports = __webpack_public_path__ + "img/arr066.3994f3bb.svg";